import { createFileRoute } from '@tanstack/react-router'

import { AccountPage } from '../../../../components/pages/account/account-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/account')({
  component: () => (
    <PermissionChecker requiredPermissions={['user.read']}>
      <AccountPage />
    </PermissionChecker>
  ),
})
